<div class="modal-header">
  <h4 class="modal-title pull-left"> Edit Link </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <form name="form" #f="ngForm" novalidate>
    <div class="form-group">
      <label class="crm-label">Hash</label>
      <input type="text" name="hash" [(ngModel)]="link.HASH" #NAME="ngModel" class="crm-field form-control rounded-0"
        placeholder="Link Has" readonly>
    </div>

    <div class="form-group">
      <label class="crm-label">Date Expire</label>
      <input class="form-control" #dpYMD="bsDatepicker" bsDatepicker name="expiry" [(ngModel)]="expiryDate"
        [bsConfig]="{ dateInputFormat: 'MM-DD-YYYY' }" [minDate]="minDate">
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button type="button" [disabled]="!f.form.valid" class="btn btn-rbv" (click)="onSubmit()">Update </button>
</div>

